import { render, staticRenderFns } from "./DefectLevelConfig.vue?vue&type=template&id=60cc4791&"
import script from "./DefectLevelConfig.js?vue&type=script&lang=js&"
export * from "./DefectLevelConfig.js?vue&type=script&lang=js&"
import style0 from "./DefectLevelConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports